import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Card,
  StepLabel,
  Step,
  Stepper,
  StepConnector,
} from '@material-ui/core';
import {
  Breadcrumb,
  BackdropCircular
} from 'components';
import {
  saveStoreStylesApi,
  getCurrentStoreStylesApi,
  getDefaultStoreStylesApi
} from 'api';
import ColorLibStepIcon from './ColorLibStepIcon';
import ColorsSchemas from './ColorsSchemas';
import FontsConfigurations from './FontsConfigurations';
import AdvancedConfigurations from './AdvancedConfigurations';


const ColorLibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 136deg, rgb(160 181 247) 0%, rgb(52 88 195) 50%, rgb(17 14 86) 100%)'
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 136deg, rgb(160 181 247) 0%, rgb(52 88 195) 50%, rgb(17 14 86) 100%)'
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const StylesPalette = () => {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);

  const {
    loadingCurrentStoreStyles,
    loadingDefaultStoreStyles,
    savingStylePalette
  } = useSelector((state) => state.styles_palette);

  const steps = ['Colors Schemas', 'Fonts Configurations', 'Advanced Configurations'];

  useEffect(() => {
    getCurrentStoreStylesApi({dispatch});
    getDefaultStoreStylesApi({dispatch});
  }, []);

  const handleNextStep = (step) => setActiveStep(step);

  const handleSubmit = (values, isSaveAsDefault) => {
    const configs = Object.keys(values).reduce((acc, value) => {
      const config = Object.keys(values[value]).map((path) => {
        return {
          path,
          value: values[value][path]
        };
      });
      return [...acc, ...config];
    }, []);
    saveStoreStylesApi({dispatch, configs, isSaveAsDefault});
    setActiveStep(0);
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-15">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'UI Configurations', path: '/settings#UI_configurations' },
            { name: 'Styles Palette' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <Card className="p-8 pb-20 overflow-visible">
          <Stepper activeStep={activeStep} alternativeLabel connector={<ColorLibConnector />}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={ColorLibStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === 0 &&
            <ColorsSchemas
              onStepChange={handleNextStep}
            />
          }
          {activeStep === 1 &&
            <FontsConfigurations
              onStepChange={handleNextStep}
            />
          }
          {activeStep === 2 &&
            <AdvancedConfigurations
              onStepChange={handleNextStep}
              onSubmit={handleSubmit}
            />
          }
        </Card>
      </div>
      <BackdropCircular
        loading={
          savingStylePalette ||
          loadingCurrentStoreStyles ||
          loadingDefaultStoreStyles
        }
      />
    </div>
  );
};

export default StylesPalette;
